import { render, staticRenderFns } from "./JudgeAdmin.vue?vue&type=template&id=41f1f41f&scoped=true"
import script from "./JudgeAdmin.vue?vue&type=script&lang=js"
export * from "./JudgeAdmin.vue?vue&type=script&lang=js"
import style0 from "./JudgeAdmin.vue?vue&type=style&index=0&id=41f1f41f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f1f41f",
  null
  
)

export default component.exports